import { getDataAmendmentDataandAnalytics } from '../config/server-config';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import { GOVERNANCE } from '../constants/ProductConstants';
import api from '../api';

export const GetDataAmendmentDataandAnalytics = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post(getDataAmendmentDataandAnalytics, {
      product_id: GOVERNANCE,
      token,
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export default { GetDataAmendmentDataandAnalytics };
